import 'swiper/css';
import '../scss/app.scss';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import GlobalEvents from '@dubbelspaeth/web-base/packages/globalEvents';
import FormHelper from '@dubbelspaeth/web-base/packages/formHelper';
import BlocksHelper from '@dubbelspaeth/web-base/packages/blocksHelper';
import {default as Header, HeaderPosition} from '@dubbelspaeth/web-base/packages/header';

import Slider from './_slider';

BlocksHelper.setOptions({
    rootMargin: '-40% 0% -40% 0%'
});

const selectorToLib: {[key: string]: any} = {
    '.header': function(target: HTMLElement) {
        new Header(target, {
            'position': HeaderPosition.StickyAfterFirst,
            'disableScrollOnMobile': true
        })
    },
    'form': FormHelper,
    '.block': function(target: HTMLElement) {
        BlocksHelper.add(target);
    },
    '.swiper': Slider,
};

for (const selector in selectorToLib) {
    const elements = document.querySelectorAll(selector);
    if (elements) {
        for (let i = 0; i < elements.length; i++) {
            new selectorToLib[selector](elements[i]);
        }
    }
}
 
GlobalEvents.on('imageLazyloaded', (e) => {
    const parent = e.target.parentElement;
    if (parent.classList.contains('lazy-image')) {
        parent.classList.add('lazy-image--loaded');
    }
});

Fancybox.bind('[data-fancybox]', {
    Carousel: {
        Thumbs: false,
    },
});


// Mega Menu Toggle onClick
document.querySelectorAll('.menu-item-has-children.have-mega-menu').forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();
        const megaMenuId = item.getAttribute('data-mega-menu');
        if (megaMenuId) {
            const megaMenu = document.querySelector(megaMenuId);
            if (megaMenu) {
                megaMenu.classList.toggle('active');
            }
        }
    });
});

// reload page with filters applied as get parameters
document.querySelectorAll('.holderFilter').forEach(select => {
    select.querySelectorAll('select').forEach(filterSelect => {
        filterSelect.addEventListener('change', event => {
            const holderFilter = (event.target as HTMLElement).closest('.holderFilter');
            if (holderFilter) {
                const params = new URLSearchParams(window.location.search);
                holderFilter.querySelectorAll('select').forEach(selectElement => {
                    const select = selectElement as HTMLSelectElement;
                    if (select.name) {
                        params.set(select.name, select.value);
                    }
                });
                const newUrl = window.location.pathname + '?' + params.toString();
                window.location.href = newUrl;
            }
        });
    });
});

// activate .locale-menu-wrapper on click of svg, each function
document.querySelectorAll('.locale-menu-wrapper svg').forEach(item => {
    item.addEventListener('click', event => {
        const parent = (event.target as HTMLElement).closest('.locale-menu-wrapper');
        if (parent) {
            parent.classList.toggle('active');
        }
    });
});

// close mega menu on click of close button
const megaMenuCloseButton = document.getElementById('mega-menu-close-button');
if (megaMenuCloseButton) {
    megaMenuCloseButton.addEventListener('click', () => {
        const megaMenu = document.querySelector('.mega-menu');
        if (megaMenu) {
            megaMenu.classList.remove('active');
        }
    });
}

// open mega menu on click of open button
const megaMenuOpenButton = document.getElementById('mega-menu-open-button');
if (megaMenuOpenButton) {
    megaMenuOpenButton.addEventListener('click', () => {
        const megaMenu = document.querySelector('.mega-menu');
        if (megaMenu) {
            megaMenu.classList.add('active');
        }
    });
}

// on click .mega-menu--xs-menu--open, parent->parent toggle .active
document.querySelectorAll('.mega-menu--xs-menu--open').forEach(item => {
    item.addEventListener('click', event => {
        const parent = (event.target as HTMLElement).closest('.mega-menu--xs-menu--open');
        if (parent && parent.parentElement && parent.parentElement.parentElement) {
            parent.parentElement.parentElement.classList.toggle('active');
        }
    });
});

// on click .mega-menu--xs-submenu--open, parent->parent toggle .active
document.querySelectorAll('.mega-menu--xs-submenu--open').forEach(item => {
    item.addEventListener('click', event => {
        const parent = (event.target as HTMLElement).closest('.mega-menu--xs-submenu--open');
        if (parent && parent.parentElement && parent.parentElement.parentElement) {
            parent.parentElement.parentElement.classList.toggle('active');
        }
    });
});